import { type ComponentProps } from 'react';

import { cn } from '@/lib/utils';

import { Skeleton } from './skeleton';

// Uneven on purpose: equal bars read as a grid, not as text.
const WIDTHS = [
  ['34%', '22%'],
  ['28%', '30%'],
  ['38%', '18%'],
  ['30%', '26%'],
  ['26%', '20%'],
];

/** A `Panel` while its list loads: same frame, a header line, then `rows` rows. */
export const PanelSkeleton = ({
  rows = 5,
  className,
  ...props
}: ComponentProps<'section'> & { rows?: number }) => (
  <section
    aria-busy
    aria-label="Loading"
    className={cn('flex flex-col rounded-xl bg-card px-2 pb-2', className)}
    {...props}
  >
    <header className="flex min-h-12 items-center gap-2 px-2 py-1.5">
      <Skeleton className="size-4" />
      <Skeleton className="h-3.5 w-28" />
      <div className="h-4.5 w-7 rounded-full bg-background" />
    </header>
    <div className="flex flex-col rounded-lg bg-background px-2 pb-1">
      <div className="flex h-8 items-center gap-4 px-2">
        <div className="h-2.5 w-1/5 rounded-sm bg-accent/60" />
        <div className="h-2.5 w-1/8 rounded-sm bg-accent/60" />
        <div className="ml-auto h-2.5 w-12 rounded-sm bg-accent/60" />
      </div>
      {Array.from({ length: rows }, (_, index) => {
        const [first, second] = WIDTHS[index % WIDTHS.length] ?? [];
        return (
          <div
            key={index}
            className="flex h-9 items-center gap-4 border-t px-2"
          >
            <Skeleton className="h-3.5" style={{ width: first }} />
            <Skeleton className="h-3.5" style={{ width: second }} />
            <Skeleton className="ml-auto h-3.5 w-12" />
          </div>
        );
      })}
    </div>
  </section>
);
